export function buildMediaVaultUnreachableDetail(cloudflareErrorCode?: string | null): string {
  const codeSuffix = cloudflareErrorCode ? ` (Cloudflare error ${cloudflareErrorCode})` : '';
  return `Snow Titan media server is unreachable. The Cloudflare tunnel is down${codeSuffix}. Check the Snow Titan connection and try again.`;
}
